export class UnitModel {
  unitId: number = 0;
  code: string = '';
  name: string = '';
  isTypeInventory: boolean = false;
  isTypeRental: boolean = false;
  unitDefault: boolean = false;
  isTypeQuotation: boolean = false;
  isTypeMaintenance: boolean = false;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}